var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"me"},[_c('h1',[_vm._v("Facility Map")]),_c('FacilityMap',{attrs:{"facilities":_vm.facilities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }